import React, { useState, useEffect } from "react";
import { Navigate, useParams } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Styling/InvoiceCard.css";
import "../Styling/Fields.css";
import { useAuth } from "../Context/AuthContext";
import { useNavigate } from "react-router-dom";
import {
  fetchCompanyCodes,
  fetchCustomers,
  fetchProjects,
  fetchItems,
  fetchResources,
  fetchVendors,
  fetchTaxCodes,
  fetchHSNCodes,
  saveInvoiceItems,
  fetchOrgHsn,
  fetchItemsByOrgId,
  fetchBatchByItem,
  fetchBatchPrice,
  fetchgstdetails
} from "../Api/IncomingPo";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Base_URL } from "../url";

const CreateInvoiceItem = () => {
  const navigate=useNavigate();
  const { user } = useAuth();
  const { invoiceId } = useParams();
  const userId = localStorage.getItem("userId") || "5";
  const [companyCodes, setCompanyCodes] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [projects, setProjects] = useState([]);
  const [items, setItems] = useState([]);
  const [resources, setResources] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [taxCodes, setTaxCodes] = useState([]);
  const [hsnCodes, setHsnCodes] = useState([]);
  const [showHsn, setShowHsn] = useState([]);
  const [loadingCompanyCodes, setLoadingCompanyCodes] = useState(false);
  const [loadingCustomers, setLoadingCustomers] = useState(false);
  const [loadingProjects, setLoadingProjects] = useState(false);
  const [loadingItems, setLoadingItems] = useState(false);
  const [loadingResources, setLoadingResources] = useState(false);
  const [loadingVendors, setLoadingVendors] = useState(false);
  const [loadingTaxCodes, setLoadingTaxCodes] = useState(false);
  const [loadingHsnCodes, setLoadingHsnCodes] = useState(false);
  const [taxAmount,setTaxAmount]=useState(0);
  const [selectItemHsn, setSelectItemHsn] = useState("");
  const[itemvalue,setValue]=useState(); 
  const [invoiceData, setInvoiceData] = useState({
    transactionType: "Invoice",
    companyCode: "",
    category: "",
    customerCode: "",
    projectCode: "",
    poNumber: "",
    poDate: "",
    salespersonCode: "",
    createdBy: userId,
    itemData: [{
      item: "",
      resource: "",
      vendor: "",
      quantity: "",
      price: "",
      taxType: "",
      // cgst: "",
      // sgst: "",
      // igst: "",
      hsn: "",
      grandTotal: "",
      batchId: "",
      UOM: "",
      // scgstAmount: "",
      // igstAmount: "",
      discountPercent: "0",
      discountValue: "",
      taxableValue: 0,
    }]
  });
  console.log(items);
  // --- new effect: load existing invoice items when invoiceId is present ---
useEffect(() => {
  if (!invoiceId) return;

  const fetchItemsAgainstInvoice = async () => {
    try {
      // show a local loading flag if you want (not required)
      const res = await fetch(`${Base_URL}/Invoices/ItemsAgainstinvoiceId/id?id=${encodeURIComponent(invoiceId)}`);
      if (!res.ok) throw new Error(`Failed to fetch items: ${res.status}`);
      const data = await res.json();

      if (!Array.isArray(data) || data.length === 0) {
        // no items returned: keep default single blank row
        return;
      }

      // Map API objects to the component's item row shape
      const mappedItems = data.map((row) => {
        return {
          // core fields used in your UI
          item: row.item ?? "",               // item code
          resource: row.resource ?? "",
          vendor: row.vendor ?? "",
          quantity: row.quantity ?? "",       // keep as string (inputs expect strings)
          price: row.price ?? "",
          taxType: row.taxType ?? "",

          // taxes
          cgst: row.cgst ?? "0",
          sgst: row.sgst ?? "0",
          igst: row.igst ?? "0",

          // other fields
          hsn: row.hsn ?? "",
          grandTotal: row.grandTotal ?? "",
          batchId: row.batchId ?? "",
          UOM: row.unitCode ?? row.UOM ?? "",

          // discount/taxable names mapped
          discountPercent: row.discPercent ?? row.discPercent ?? "0",
          discountValue: row.discountValue ?? "",
          taxableValue: row.taxableValue ?? (row.taxableValue === 0 ? 0 : row.taxableValue) ?? 0,

          // optional helper fields (keep if your UI used them)
          scgstAmount: row.cgstAmount ?? null,
          igstAmount: row.igstAmount ?? null,
          batchLabel: "", // will be filled if you load batches later
          // keep itemId if you need it later for edits/deletes
          itemId: row.itemId ?? null,
        };
      });

      // set the invoiceData to include these items
      setInvoiceData((prev) => ({
        ...prev,
        // keep existing header fields but replace itemData
        itemData: mappedItems.length > 0 ? mappedItems : prev.itemData,
      }));

      // optionally fetch batches per item if you want to prefill batch lists:
      // for each mapped item with an item code you could call fetchBatchByItem and set batchItemsByIndex
      // (only do this if you need pre-populated batch dropdowns)
      // Example (non-blocking):
      mappedItems.forEach(async (it, idx) => {
        if (it.item) {
          try {
            const batches = await fetchBatchByItem(it.item);
            setBatchItemsByIndex((prev) => ({ ...prev, [idx]: batches || [] }));
          } catch (e) {
            // ignore batch fetching errors
            console.warn("batch load failed for item", it.item, e);
          }
        }
      });

    } catch (err) {
      console.error("Error fetching items against invoiceId:", err);
      toast.error("Failed to load invoice items");
    }
  };

  fetchItemsAgainstInvoice();
}, [invoiceId]);

  const [savingItems, setSavingItems] = useState(false);
  const [batchItemsByIndex, setBatchItemsByIndex] = useState({});
  const categoryOptions = [
    { value: "New Project", label: "New Project" },
    { value: "CR to Existing Project", label: "CR to Existing Project" },
    { value: "Staffing Requirement", label: "Staffing Requirement" },
    { value: "Extension of Staffing", label: "Extension of Staffing" },
  ];

  const calculatePriceSummary = () => {
    let totalBasePrice = 0;
    let totalTaxAmount = 0;
    let totalPrice = 0;
    let roundedTotalPrice = 0;
    let roundOff = 0;

    invoiceData.itemData.forEach(item => {
      const quantity = parseFloat(item.quantity) || 0;
      const price = parseFloat(item.price) || 0;
      const cgst = parseFloat(item.cgst) || 0;
      const sgst = parseFloat(item.sgst) || 0;
      const igst = parseFloat(item.igst) || 0;

      const basePrice = quantity * price;
      const taxAmount = basePrice * ((cgst + sgst + igst) / 100);

      totalBasePrice += basePrice;
      totalTaxAmount += taxAmount;
      totalPrice += basePrice + taxAmount;
    });

    roundedTotalPrice = totalPrice;
    roundOff = roundedTotalPrice - totalPrice;

    return {
      totalBasePrice: totalBasePrice.toFixed(2),
      totalTaxAmount: totalTaxAmount.toFixed(2),
      totalPrice: totalPrice.toFixed(2),
      roundedTotalPrice: roundedTotalPrice.toFixed(2),
      roundOff: roundOff.toFixed(2)
    };
  };

  const priceSummary = calculatePriceSummary();

  useEffect(() => {
    const loadData = async () => {
      setLoadingCompanyCodes(true);
      setLoadingCustomers(true);
      setLoadingProjects(true);
      setLoadingItems(true);
      setLoadingResources(true);
      setLoadingVendors(true);
      setLoadingTaxCodes(true);
      setLoadingHsnCodes(true);

      try {
        const [
          companyCodesData,
          customersData,
          projectsData,
          itemsData,
          resourcesData,
          vendorsData,
          taxCodesData,
          hsnCodesData,
          showHsn,
        ] = await Promise.all([
          fetchCompanyCodes(),
          fetchCustomers(),
          fetchProjects(),
          fetchItemsByOrgId(user.organisationId),
          fetchResources(user?.organisationId),
          fetchVendors(),
          fetchTaxCodes(),
          fetchHSNCodes(),
          fetchOrgHsn(user.organisationId),
        ]);

        setCompanyCodes(companyCodesData);
        setCustomers(customersData);
        setProjects(projectsData);
        setItems(itemsData);
        setResources(resourcesData);
        setVendors(vendorsData);
        setTaxCodes(taxCodesData);
        setHsnCodes(hsnCodesData);
        setShowHsn(showHsn);
        // setBatch(showBatch);
      } catch (error) {
        toast.error("Failed to load data");
        console.error("Error loading data:", error);
      } finally {
        setLoadingCompanyCodes(false);
        setLoadingCustomers(false);
        setLoadingProjects(false);
        setLoadingItems(false);
        setLoadingResources(false);
        setLoadingVendors(false);
        setLoadingTaxCodes(false);
        setLoadingHsnCodes(false);
      }
    };

    loadData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInvoiceData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  // console.log("Invoice Data", invoiceData);

  // component state



const handleItemChange = async (index, e) => {
  const { name, value } = e.target;
  console.log("changed", index, name, value);

  // sanitize numbers
  const numericFields = [
    "quantity",
    "price",
    "cgst",
    "sgst",
    "igst",
    "grandTotal",
    "discountPercent",
  ];
  const cleanedValue = numericFields.includes(name)
    ? value.replace(/[^0-9.]/g, "")
    : value;

  // helper to (re)compute row totals and normalize string values for inputs
  const recomputeRow = (row) => {
    const quantityNum = parseFloat(row.quantity) || 0;
    const priceNum = parseFloat(row.price) || 0;
    const discountPercentNum = parseFloat(row.discountPercent) || 0;

    const subtotal = quantityNum * priceNum;
    const discountValueNum = subtotal * (discountPercentNum / 100);

    const taxableAmount = subtotal - discountValueNum;

    const cgstPercent = parseFloat(row.cgst) || 0;
    const sgstPercent = parseFloat(row.sgst) || 0;
    const igstPercent = parseFloat(row.igst) || 0;

    const taxAmount =
      taxableAmount * ((cgstPercent + sgstPercent + igstPercent) / 100);

    const grandTotalNum = taxableAmount + taxAmount;

    return {
      ...row,
      // keep as strings for controlled inputs
      discountValue: discountValueNum.toFixed(2),
      grandTotal: grandTotalNum.toFixed(2).toString(),
    };
  };

  // 1) write the raw change
  setInvoiceData((prev) => {
    const itemData = [...prev.itemData];
    const existing = itemData[index] ?? {};
    const updated = { ...existing, [name]: cleanedValue };

    // recompute on any field that affects totals
    const shouldRecalculate =
      ["quantity", "price", "discountPercent", "cgst", "sgst", "igst"].includes(
        name
      );

    itemData[index] = shouldRecalculate ? recomputeRow(updated) : updated;
    return { ...prev, itemData };
  });

  // 2) If item changed, fetch batches + GST and then recompute
  if (name === "item") {
    const batchList = await fetchBatchByItem(cleanedValue);
    setBatchItemsByIndex((prev) => ({ ...prev, [index]: batchList || [] }));

    // get GST details by HSN for the selected itemCode
    const filteredItem = items.find((it) => it.itemCode === cleanedValue);
    const hsnId = filteredItem?.hsnId;
    const gstdetails = hsnId ? await fetchgstdetails(invoiceId, hsnId) : null;

    if (batchList && batchList.length > 0) {
      const chosenBatch = batchList[0];
      const priceResp = await fetchBatchPrice(chosenBatch.batchId);

      setInvoiceData((prev) => {
        const itemData = [...prev.itemData];
        const row = { ...(itemData[index] ?? {}) };

        row.hsn = hsnId ?? row.hsn;
        row.batchId = chosenBatch.batchId;
        row.batchLabel = chosenBatch.batchNoLabel ?? row.batchLabel;

        // prefer API price if available
        const apiPrice = priceResp?.ptrExclGst;
        if (apiPrice !== undefined && apiPrice !== null && apiPrice !== "") {
          row.price = String(apiPrice);
        }

        // use the selected item's UOM (not items[index])
        if (filteredItem?.skuUnit) {
          row.UOM = filteredItem.skuUnit;
        }

        if (gstdetails) {
          row.cgst = String(gstdetails.cgstPercent ?? 0);
          row.sgst = String(gstdetails.sgstPercent ?? 0);
          row.igst = String(gstdetails.igstPercent ?? 0);
        }

        itemData[index] = recomputeRow(row);
        return { ...prev, itemData };
      });
    } else {
      // still recompute if GST got applied or price/UOM changed
      setInvoiceData((prev) => {
        const itemData = [...prev.itemData];
        const row = { ...(itemData[index] ?? {}) };

        row.hsn = hsnId ?? row.hsn;

        if (gstdetails) {
          row.cgst = String(gstdetails.cgstPercent ?? 0);
          row.sgst = String(gstdetails.sgstPercent ?? 0);
          row.igst = String(gstdetails.igstPercent ?? 0);
        }

        if (filteredItem?.skuUnit) {
          row.UOM = filteredItem.skuUnit;
        }

        itemData[index] = recomputeRow(row);
        return { ...prev, itemData };
      });
    }
  }

  // 3) If batch changed, update price/labels and recompute
  if (name === "batchId") {
    const selectedBatchId = cleanedValue;
    const batchesForRow = batchItemsByIndex[index] || [];
    const selectedBatchObj = batchesForRow.find(
      (b) => String(b.batchId) === String(selectedBatchId)
    );

    if (selectedBatchObj) {
      const priceResp = await fetchBatchPrice(selectedBatchObj.batchId);

      setInvoiceData((prev) => {
        const itemData = [...prev.itemData];
        const row = { ...(itemData[index] ?? {}) };

        row.batchId = String(selectedBatchObj.batchId);
        row.batchLabel = String(selectedBatchObj.batchNoLabel ?? "");
        const apiPrice = priceResp?.ptrExclGst;
        if (apiPrice !== undefined && apiPrice !== null && apiPrice !== "") {
          row.price = String(apiPrice);
        }

        itemData[index] = recomputeRow(row);
        return { ...prev, itemData };
      });
    } else {
      // just set the selected ID and leave others intact; no recompute needed
      setInvoiceData((prev) => {
        const itemData = [...prev.itemData];
        const row = { ...(itemData[index] ?? {}) };
        row.batchId = String(selectedBatchId);
        itemData[index] = row;
        return { ...prev, itemData };
      });
    }
  }
};











  const handleTaxTypeChange = (index, e) => {
    const { value } = e.target;
    const itemData = [...invoiceData.itemData];
    const selectedTax = taxCodes.find(tax => tax.code === value);

    if (selectedTax) {
      itemData[index] = {
        ...itemData[index],
        taxType: value,
        cgst: selectedTax.cgst?.toString() || "0",
        sgst: selectedTax.sgst?.toString() || "0",
        igst: selectedTax.igst?.toString() || "0"
      };

      const quantity = parseFloat(itemData[index].quantity);
      const price = parseFloat(itemData[index].price);
      const cgst = parseFloat(itemData[index].cgst);
      const sgst = parseFloat(itemData[index].sgst);
      const igst = parseFloat(itemData[index].igst);

      const subtotal = quantity * price;
      const taxAmount = subtotal * ((cgst + sgst + igst) / 100);
      const grandTotal = subtotal + taxAmount;
      console.log(grandTotal);
      const scgstAmount = subtotal * (sgst / 100)
      itemData[index].scgstAmount = scgstAmount
      const icgstAmount = subtotal * (igst / 100)
      itemData[index].igstAmount = icgstAmount
      itemData[index].grandTotal = Math.round(grandTotal).toString();
      itemData[index].taxableValue = subtotal
    }

    setInvoiceData({ ...invoiceData, itemData });
  };

  const addNewItem = () => {
    setInvoiceData({
      ...invoiceData,
      itemData: [
        ...invoiceData.itemData,
        {
          item: "",
          resource: "",
          vendor: "",
          quantity: "",
          price: "",
          taxType: "",
          // cgst: "",
          // sgst: "",
          // igst: "",
          hsn: "",
          grandTotal: "",
          batchId: "",
          UOM: "",
          // scgstAmount: "",
          // igstAmount: "",
          discountPercent: "0",
          discountValue: "",
          taxableValue: 0
        }
      ]
    });
  };

  const removeItem = (index) => {
    if (invoiceData.itemData.length === 1) {
      toast.warning("At least one item is required");
      return;
    }

    const itemData = [...invoiceData.itemData];
    itemData.splice(index, 1);
    setInvoiceData({ ...invoiceData, itemData });
  };

  const handleSaveItems = async () => {
    setSavingItems(true);

    try {
      const itemsData = {
        invoiceId: invoiceId,
        createdBy: userId,
        invoiceItem: invoiceData.itemData
      };
      console.log("to send", itemsData);

      const response = await saveInvoiceItems(itemsData);
      toast.success(
        <div>
          <div className="fw-bold">Items Saved Successfully!</div>
          <div>Invoice ID: {invoiceId}</div>
        </div>,
        {
          autoClose: 5000,
          closeOnClick: true,
          pauseOnHover: true,
        }
      );

    } catch (error) {
      console.error("Error saving invoice items:", error);

      let errorMessage = "Failed to save invoice items. Please try again.";
      if (error.message) {
        errorMessage = error.message;
      } else if (typeof error === 'string') {
        errorMessage = error;
      }

      toast.error(errorMessage, {
        autoClose: 5000,
        closeOnClick: true,
        pauseOnHover: true,
      });
    } finally {
      setSavingItems(false);
    }
  };

  const isLoading = loadingCompanyCodes || loadingCustomers ||
    loadingProjects || loadingItems || loadingResources ||
    loadingVendors || loadingTaxCodes || loadingHsnCodes;

  return (
    <div className="container-fluid py-4">
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      <div className="card shadow-sm border-0 rounded-4 p-4 invoice-card mb-4">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <h4 className="fw-bold text-dark mb-1">
              Add Items to Invoice
              <span className="badge bg-success-light text-success ms-2">
                Invoice ID: {invoiceId}
              </span>
            </h4>
            <p className="text-muted mb-2">
              Add items and complete your invoice
            </p>
          </div>

          <div className="d-flex gap-2">
            <button
              className="btn btn-outline-primary rounded-3 fw-semibold"
              onClick={handleSaveItems}
              disabled={savingItems || isLoading}
            >
              {savingItems ? 'Saving...' : '💾 Save Draft'}
            </button>
            <button className="btn btn-warning rounded-3 fw-semibold text-white">
              🔐 Generate IRN
            </button>
            <button className="btn btn-success rounded-3 fw-semibold">
              ✅ Post Invoice
            </button>
            <button className="btn btn-success rounded-3 fw-semibold" onClick={()=>navigate("/batchmaster")}>
              Create New Batch
            </button>
          </div>
        </div>
      </div>

      <div className="fields-form">
        <div className="d-flex align-items-center mb-4">
          <div className="icon-box me-2">
            📦
          </div>
          <h5 className="fw-bold mb-0 text-dark fields-title">Invoice Items</h5>
        </div>

        {/* Price Summary Section */}
        <div className="card shadow-sm border-0 rounded-4 p-4 mt-4">
          <div className="d-flex align-items-center mb-3">
            <div className="icon-box me-2">
              💰
            </div>
            <h6 className="fw-bold mb-0 text-dark">Price Summary</h6>
          </div>

          <div className="row g-3">
            <div className="col-md-3">
              <label className="form-label fw-semibold">Total Base Price</label>
              <input
                type="text"
                className="form-control"
                value={priceSummary.totalBasePrice}
                readOnly
              />
            </div>
            <div className="col-md-3">
              <label className="form-label fw-semibold">Total Tax Amount</label>
              <input
                type="text"
                className="form-control"
                value={priceSummary.totalTaxAmount}
                readOnly
              />
            </div>
            <div className="col-md-3">
              <label className="form-label fw-semibold">Round off</label>
              <input
                type="text"
                className="form-control"
                value={priceSummary.roundOff}
                readOnly
              />
            </div>
            <div className="col-md-3">
              <label className="form-label fw-semibold">Total Amount</label>
              <input
                type="text"
                className="form-control"
                value={priceSummary.roundedTotalPrice}
                readOnly
              />
            </div>
          </div>
        </div>

        {/* Item Data Section */}
        <div className="item-data-section mt-4">
          <div className="d-flex align-items-center mb-3">
            <div className="icon-box me-2">
              📦
            </div>
            <h6 className="fw-bold mb-0 text-dark item-data-heading">Item Data</h6>
          </div>

          {invoiceData.itemData.map((item, index) => (
            <div key={index} className="item-data-container">
              <div className="item-data-row">
                {/* Item */}
                <div className="item-data-field" style={{ width: '180px' }}>
                  <label className="form-label fw-semibold">
                    Item <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select"
                    name="item"
                    value={item.item}
                    onChange={(e) => handleItemChange(index, e)}
                    required
                    disabled={loadingItems}
                  >
                    <option value="">Select Item</option>
                    {items.map((itemOption) => (
                      <option key={itemOption.itemCode} value={itemOption.itemCode}>
                        {itemOption.itemCode} - {itemOption.itemName}
                      </option>
                    ))}
                  </select>
                </div>
                {/* BATCH */}
                {/* BATCH */}
{showHsn.batchRelevant === "Y" && (
  <div className="item-data-field" style={{ width: "100px" }}>
    <label className="form-label fw-semibold">BATCH</label>

    <select
      className="form-control"
      name="batchId"
      value={item.batchId || ""} // item.batchId should be the real id
      // don't make it readOnly unless you really want to prevent change:
      // readOnly={!!item.batchId}
      onChange={(e) => handleItemChange(index, e)}
    >
      <option value="">Select Batch</option>
      {(batchItemsByIndex[index] || []).map((b) => (
        // value is batchId (the actual id), label shows batchNoLabel
        <option key={b.batchId} value={b.batchId}>
          {b.batchNoLabel}
        </option>
      ))}
    </select>
  </div>
)}


                {/* Vendor */}
                {showHsn.vendorOnInvLine == 'Y' && <div className="item-data-field" style={{ width: '180px' }}>
                  <label className="form-label fw-semibold">Vendor</label>
                  <select
                    className="form-select"
                    name="vendor"
                    value={item.vendor}
                    onChange={(e) => handleItemChange(index, e)}
                    disabled={loadingVendors}
                  >
                    <option value="">Select Vendor</option>
                    {vendors.map((vendor) => (
                      <option key={vendor.vendorCode} value={vendor.vendorCode}>
                        {vendor.vendorCode} - {vendor.vendorName}
                      </option>
                    ))}
                  </select>
                </div>}
              
                {/* Quantity */}
                <div className="item-data-field" style={{ width: '120px' }}>
                  <label className="form-label fw-semibold">
                    Qty <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="quantity"
                    value={item.quantity}
                    onChange={(e) => handleItemChange(index, e)}
                    required
                  />
                </div>

                {/* Price */}
                <div className="item-data-field" style={{ width: '120px' }}>
                  <label className="form-label fw-semibold">
                    Price <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="price"
                    value={item.price}
                    onChange={(e) => handleItemChange(index, e)}
                    required
                  />
                </div>

                {/* HSN */}
                {showHsn.hsnOnInvLine == 'Y' && <div className="item-data-field" style={{ width: '150px' }}>
                  <label className="form-label fw-semibold">
                    HSN <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select"
                    name="hsn"
                    value={item.hsn}
                    onChange={(e) => handleItemChange(index, e)}
                    required
                    disabled={loadingHsnCodes}
                  >
                    <option value="">Select HSN</option>
                    {hsnCodes.map((hsn) => (
                      <option key={hsn.code} value={hsn.code}>
                        {hsn.code} - {hsn.name}
                      </option>
                    ))}
                  </select>
                </div>}

                {/* Tax Code */}
                {/* <div className="item-data-field" style={{ width: '180px' }}>
                  <label className="form-label fw-semibold">
                    Tax Code <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select"
                    name="taxType"
                    value={item.taxType}
                    onChange={(e) => handleTaxTypeChange(index, e)}
                    required
                    disabled={loadingTaxCodes}
                  >
                    <option value="">Select Tax Code</option>
                    {taxCodes.map((tax) => (
                      <option key={tax.code} value={tax.code}>
                        {tax.code} - {tax.description}
                      </option>
                    ))}
                  </select>
                </div> */}

                {/* {CGST } */}
                {/* <div className="item-data-field" style={{ width: '100px' }}>
                  <label className="form-label fw-semibold">CGST %</label>
                  <input
                    type="text"
                    className="form-control"
                    name="cgst"
                    value={item.cgst}
                    onChange={(e) => handleItemChange(index, e)}
                  />
                </div> */}

                {/* SGST */}
                {/* <div className="item-data-field" style={{ width: '100px' }}>
                  <label className="form-label fw-semibold">SGST %</label>
                  <input
                    type="text"
                    className="form-control"
                    name="sgst"
                    value={item.sgst}
                    onChange={(e) => handleItemChange(index, e)}
                  />
                </div>  */}

                {/* IGST */}
                {/* { <div className="item-data-field" style={{ width: '100px' }}>
                  <label className="form-label fw-semibold">IGST %</label>
                  <input
                    type="text"
                    className="form-control"
                    name="igst"
                    value={item.igst}
                    onChange={(e) => handleItemChange(index, e)}
                  />
                </div> } */}

                {/* Grand Total */}

                <div className="item-data-field" style={{ width: '120px' }}>
                  <label className="form-label fw-semibold">Discount%</label>
                  <input
                    type="number"
                    className="form-control"
                    name="discountPercent"
                    value={item.discountPercent}
                    onChange={(e) => handleItemChange(index, e)}
                  />
                </div>
                <div className="item-data-field" style={{ width: '120px' }}>
                  <label className="form-label fw-semibold">Discount Value</label>
                  <input
                    type="text"
                    className="form-control"
                    name="discountValue"
                    value={item.discountValue}
                    readOnly
                  />
                </div>
                <div className="item-data-field" style={{ width: '120px' }}>
                  <label className="form-label fw-semibold">Grand Total</label>
                  <input
                    type="text"
                    className="form-control"
                    name="grandTotal"
                    value={item.grandTotal}
                    readOnly
                  />
                </div>

                {/* Action Buttons */}
                <div className="item-data-field" style={{ width: '200px', paddingTop: '25px' }}>
                  <button
                    type="button"
                    className="btn btn-danger rounded-3 fw-semibold item-action-btn me-2"
                    onClick={() => removeItem(index)}
                    disabled={invoiceData.itemData.length === 1}
                  >
                    Remove
                  </button>
                  {index === invoiceData.itemData.length - 1 && (
                    <button
                      type="button"
                      className="btn btn-success rounded-3 fw-semibold item-action-btn"
                      onClick={addNewItem}
                    >
                      Add Item
                    </button>
                  )}
                </div>
              </div>
            </div>
          ))}

          {/* Save Items Button */}
          <div className="fields-btn-container mt-4">
            <button
              type="button"
              className="btn btn-primary rounded-3 fw-semibold px-4 fields-submit"
              onClick={handleSaveItems}
              disabled={savingItems || isLoading}
            >
              {savingItems ? 'Saving Items...' : '💾 Save Invoice'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateInvoiceItem;